var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { a as assignGlobalSingleton } from "../global-33d5eebf.js";
import { Spine } from "pixi-spine";
import * as PIXI from "pixi.js";
class PixiSpineLoader {
  constructor() {
    __publicField(this, "pixiSpineLibrary", /* @__PURE__ */ new Map());
  }
  static getInstance() {
    return assignGlobalSingleton("PixiSpineLoader", () => new PixiSpineLoader());
  }
  async loadSpine(name, assetPath) {
    const resource = await PIXI.Assets.load(assetPath);
    this.pixiSpineLibrary.set(name, resource);
  }
  get(name) {
    const resource = this.pixiSpineLibrary.get(name);
    if (!resource) {
      throw new Error(`Spine resource ${name} not found`);
    }
    return new Spine(resource.spineData);
  }
}
export {
  PixiSpineLoader
};
//# sourceMappingURL=PixiSpineLoader.js.map
